export default function Youtube({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.426"
      height="17.814"
      viewBox="0 0 23.426 17.814"
      {...props}
    >
      <path
        d="M18.5 17.314H4.922a4.4 4.4 0 0 1-2.473-.755 4.434 4.434 0 0 1-1.6-1.946A4.395 4.395 0 0 1 .5 12.891V4.922a4.4 4.4 0 0 1 .755-2.472A4.436 4.436 0 0 1 3.2.848 4.4 4.4 0 0 1 4.922.5H18.5a4.4 4.4 0 0 1 2.473.755 4.435 4.435 0 0 1 1.6 1.946 4.394 4.394 0 0 1 .348 1.721v7.969a4.4 4.4 0 0 1-.755 2.473 4.436 4.436 0 0 1-1.946 1.6 4.395 4.395 0 0 1-1.72.35ZM9.163 4.468a.746.746 0 0 0-.283.056.762.762 0 0 0-.24.156.741.741 0 0 0-.229.54v7.375a.741.741 0 0 0 .229.54.76.76 0 0 0 .24.156.741.741 0 0 0 .667-.052l6.163-3.688a.75.75 0 0 0 0-1.288L9.547 4.575a.75.75 0 0 0-.384-.107Z"
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
